<template>
  <div class="home">
    <HeaderComponent screenName=""/>
    <!-- Business Banner -->
    <BannerComponent
      imageSrc="capabilities/digital services/digitalservices-banner.jpg"
      :bannerHeadingColor="'#fff'"
      :isOverlay="true"
      heading="Digital Services"
      subheading="Transforming Strategies into Digital Realities"
    />

    <div class="modernization-description" data-aos="fade-up">
      <v-row>
        <v-col
          :xs="12"
        >
          <p> {{ appModernizationDesc }} </p>
        </v-col>
      </v-row>
    </div>
    <CardComponent 
      :subHeading="`BENEFITS`"
      :cardItems="benefitsItems"
    />
    <CardComponent 
      :subHeading="`CORE CAPABILITIES`"
      :cardItems="coreCapabilitiesItems"
    />
    <SectionComponent
       relatedTitle="RELATED CAPABILITIES"
       paragraphContent="G14C Digital Services have evolved and adapted over several decades transforming business and modernizing systems and applications for the Federal, State and Local governments, Industry and Non-Profits. Our services provide the convenience of accessing information, products, and services anytime, anywhere, while on the go, and available 24/7, making it easy to access information and conduct transactions and communications from various devices. Our Digital Services provide tailored content and recommendations based on your preferences, creating a more personalized and engaging experience. We provide a wide range of digital services to choose from, providing options based on specific workflows, access requirements, and user activities, roles and responsibilities, with robust security to protect personal information."
      :sections="sectionContents"
      :cards="cardData"
      :additional-content="additionalContent"
    />
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import BannerComponent from '@/components/BannerComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import SectionComponent from '@/components/SectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    BannerComponent,
    CardComponent,
    SectionComponent,
    FooterComponent
  },
  data() {
    return {
      appModernizationDesc: 'G14C Digital Services provide customers with a broad range of capabilities and solutions delivered electronically utilizing digital technology including Software as a Service (SaaS), UI/IX Design, Data Fabric Architecture, Analytics, and Process Automation. G14C’s Digital Services have evolved and adapted over decades providing customers in the Federal, State, and Local government sectors, as well as commercial clients, and non-profits with deep and broad capabilities for transforming your business. Utilize our proven approach to transform your business by engaging G14C for integrating digital technologies that fundamentally change and improve how the business operates by delivering value to users, customers, and partners.',
      benefitsItems: [
        {
          id: 0,
          subFolder:'capabilities', 
          folder:'digital services',
          imageUrl: 'insight.jpg',
          text: 'Actionable Insights',
          hoverIcon: 'vector.png',
          hoverText: 'Generate a wealth of data for analyzes to gain actionable insights into user behavior, preferences, and trends to inform decision-makers for improving products and services. Utilizes AI/ML technologies to analyze data assets providing actionable information for making timely and informed decisions.'
        },{
          id: 1,
          subFolder:'capabilities',  
          folder:'digital services',
          imageUrl: 'Collaboration.jpg',
          text: 'Advanced Collaboration',
          hoverIcon: 'chart.png',
          hoverText: 'Facilitate collaboration among individuals and business units across geographic boundaries utilizing  video conferencing, cloud-based document sharing, and project management software to effectively work together remotely.'
        },{
          id: 2,
          subFolder:'capabilities',  
          folder:'digital services',
          imageUrl: 'User Experience.jpg',
          text: 'Enhanced User Experience',
          hoverIcon: 'trend-down.png',
          hoverText: 'Provide users a seamless and meaningful user experience while interacting with business applications through aesthetically pleasing user interfaces (UIs) built on Human Centered Design (HCD) principles. Tailor content and recommendations to individual preferences and behaviors, providing users with a more personalized experience enhancing user satisfaction and engagement.'
        },{
          id: 3,
          subFolder:'capabilities', 
          folder:'digital services',
          imageUrl: 'quality.jpg',
          text: 'Improved Quality',
          hoverIcon: 'lock.png',
          hoverText: 'Reduce human errors and improve quality and increase productivity through the adoption of AI/ML, Robotic Process Automation (RPA), and test driven development (TDD) techniques.'
        },{
          id: 4,
          subFolder:'capabilities', 
          folder:'digital services',
          imageUrl: 'innovation.jpg',
          text: 'Innovation',
          hoverIcon: 'trend-down.png',
          hoverText: 'Fosters innovation agility by enabling the development of new technologies, services, and business models to drive economic growth, and cost effectiveness while improving quality. Quickly adapt to changing market conditions by reducing the time to market for delivering innovative products and services.'
        },{
          id: 5,
          subFolder:'capabilities',  
          folder:'digital services',
          imageUrl: 'Empowerment.jpg',
          text: 'Workforce Empowerment',
          hoverIcon: 'lock.png',
          hoverText: 'Empower the workforce through digital transformation with the tools and technologies they need to be more effective in their roles. This includes access to data for decision making and business application that provides a positive user experience.'
        }
      ],
      
      coreCapabilitiesItems: [
        {
          id: 6,
          subFolder:'capabilities', 
          folder:'digital services',
          imageUrl: 'Data Analytics.jpg',
          text: 'Data Analytics ',
          hoverIcon: 'analysis.png',
          hoverText: 'Accelerate the adoption of digital technologies for examining, cleansing, transforming, and interpreting data with the goal of extracting valuable insights, drawing conclusions, and supporting data driven business decisions through data visualization, enhanced user experiences (UXs).'
        },{
          id: 7,
          subFolder:'capabilities', 
          folder:'digital services',
          imageUrl: 'Data Architecture.jpg',
          text: 'Data Fabric Architecture ',
          hoverIcon: 'inventory.png',
          hoverText: 'Implement Data Fabric architecture using AI/ML to integrate data across the enterprise providing a consistent view of data for users to access and analyze, deriving actionable insights to make data driven business decisions.'
        },{
          id: 8,
          subFolder:'capabilities', 
          folder:'digital services',
          imageUrl: 'Healthcare.jpg',
          text: 'Digital Healthcare Services',
          hoverIcon: 'ai-brain.png',
          hoverText: 'Utilize our digital technology and information and communication technologies for managing Electronic Health Records (EHRs), creating Health Information Portals, modernizing Healthcare Information Systems, and HL7® FHIR® compliance.'
        },{
          id: 9,
          subFolder:'capabilities', 
          folder:'digital services',
          imageUrl: 'Automation.jpg',
          text: 'Process Automation',
          hoverIcon: 'cloud-done.png',
          hoverText: 'Provide digital technology such as Robotic Process Automation (RPA) to execute processes for streamlining and optimizing workflows, improving efficiency, reducing errors, and enhancing overall productivity with minimal or zero human intervention.'
        },{
          id: 10,
          subFolder:'capabilities', 
          folder:'digital services',
          imageUrl: 'Saas.jpg',
          text: 'Software as a Service (SaaS)',
          hoverIcon: 'software-license.png',
          hoverText: ' Leverage our SaaS capabilities to provide software applications where businesses and users can access these applications without needing to install or maintain software locally, for example AWS ECS, Google Workspace, Microsoft 365, Oracle E-Business, ServiceNow and Salesforce.'
        },{
          id: 11,
          subFolder:'capabilities', 
          folder:'digital services',
          imageUrl: 'ui-ux.jpg',
          text: 'UX/UI Design',
          hoverIcon: 'microservices.png',
          hoverText: 'Deliver a well-designed user interface (UI) for improving efficiency by making it easy for the users to perform business functions while having positive user experience to enhance user satisfaction while increasing productivity.'
        }
      ],
      sectionContents: [
        '“During the initial period of performance, the delivery team provided a strategic digital roadmap with tactical milestones (release features) for each quarterly release. The contractor performed exceptional by timely delivering the milestones and demonstrated great flexibility and innovation to accommodate additional features for the benefit of business and as recommended by OIT. They did so by maintaining the overall integrity and quality of each release.”',
        '“The contractor has extensive experience at the IRS. Their strengths in installation, configuration, and design and development services are exceptional.  The delivery team has strengths in collaboration and communication with other IRS stakeholders and vendors and their engineering capabilities exceeded requirements. The technical team is very knowledgeable in training other staff and this has been very beneficial to the IRS.”',
      ],
      additionalContent: [
        'HRSA, COR', 
        'IRS, Director', 
      ],
      cardData: [
        {
          className: 'devsecops',
          color: '#7594FE',
          heading: 'Application Modernization	',          
          link: 'application-modernization'
        },
        {
          className: 'cloud',
          color: '#50E1FE',
          heading: 'Business Intelligence	',
          link: 'business-intelligence'
        },
        {
          className: 'security',
          color: '#E2BF66',
          heading: 'Debt Management',
          link: 'debt-management'
        },
      ]
    };
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>
.modernization-description{
  padding: 32px;
  padding-left: 100px;
  padding-right: 100px;
}
.modernization-description div div p{
  font-size: 24px;
}
@media (max-width: 1000px) {
  .modernization-description{
    padding: 27px;
    padding-left: 80px;
    padding-right: 80px;
  }
  .modernization-description div div p{
    font-size: 24px;
  }
}
@media (max-width: 850px) {
  .modernization-description{
    padding: 22px;
    padding-left: 65px;
    padding-right: 65px;
  }
  .modernization-description div div p{
    font-size: 22px;
  }
}
@media (max-width: 750px) {
  .modernization-description{
    padding: 17px;
    padding-left: 50px;
    padding-right: 50px;
  }
  .modernization-description div div p{
    font-size: 20px;
  }
}
@media (max-width: 600px) {
  .modernization-description{
    padding: 12px;
    padding-left: 35px;
    padding-right: 35px;
  }
  .modernization-description div div p{
    font-size: 18px;
  }
}
</style>